import { useState } from 'react'

import styled from '@emotion/styled'

import VideoPlayerBase, * as VideoPlayer from '@segment/matcha/components/VideoPlayer'

import Elevation from '@segment/matcha/components/Elevation'

import Image from '@segment/matcha/components/Image'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import * as CopyText from '@segment/matcha/recipes/CopyText'

import Cover from './assets/Cover.png'

const AnalyticsForStartups = () => {
  const [playing, setPlaying] = useState(false)

  return (
    <Wrapper>
      <StyledSection variant="noCopy">
        <Section.Contents>
          <Elevation elevation={7}>
            <VideoPlayerBase
              url="https://www.youtube.com/watch?v=Yf42zrdLQfY"
              playing={playing}
              onEnded={() => setPlaying(false)}
              onPause={() => setPlaying(false)}
              onPlay={() => setPlaying(true)}
            >
              {!playing && (
                <VideoPlayer.BigPlayButton
                  ariaLabel={`Play "Analytics for Startups" Video`}
                  onClick={() => setPlaying(true)}
                  key="play-btn"
                />
              )}
              {!playing && (
                <VideoPlayer.Cover key="cover">
                  <Picture>
                    <source type="image/webp" srcSet={Cover} />
                    <StyledImage width="800" height="455" src={Cover} alt="Illustration: Cover" loading="lazy" />
                  </Picture>
                </VideoPlayer.Cover>
              )}
            </VideoPlayerBase>
          </Elevation>
          <Caption>
            <CopyText.Overline tag="h4">Analytics for startups:</CopyText.Overline>
            <CopyText.Heading variant="h4" tag="p">
              From AWS Loft, by Ilya Volodarsky, Founder at Segment
            </CopyText.Heading>
          </Caption>
        </Section.Contents>
      </StyledSection>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  max-width: 963px;
  margin: 0 auto;
`

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 40px;
  }
`

const Picture = styled.picture`
  margin: 0 auto;
`

const StyledImage = styled(Image)`
  background-color: ${({ theme }) => theme.palette.brand.darkAcai[`600`]};
  display: block;
  width: 105%;
  height: auto;
`

const Caption = styled.div`
  padding-top: 40px;
  text-align: center;
  h4,
  p {
    margin-top: 0;
    margin-bottom: 16px;
  }
`

export default AnalyticsForStartups
